import { render, staticRenderFns } from "./_CopyButton.vue?vue&type=template&id=9a9c465e"
import script from "./_CopyButton.vue?vue&type=script&lang=js"
export * from "./_CopyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports